import { dataCircleExtend } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCircleExtend = /*#__PURE__*/createIcon(dataCircleExtend)
export default IconCircleExtend
